import { AlphaJBoxIcon } from './AlphaJBoxIcon';

/**
 * author: GreenTurtwig
 * id 1472FB12-4CBA-476C-8F57-E1CB5E4213A6
 * name alpha-j-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-j-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterJBoxIcon = AlphaJBoxIcon;
export default LetterJBoxIcon